export interface featureToggleState {
  territoryAttendanceUK: boolean
  territoryAttendanceNeth: boolean
  notificationLogs: boolean
  birthdayRequest: boolean
  enhancement?: boolean
  manAuthUK: boolean
  myActionsV3?: boolean
  ukPlannerDayforceAbsence: boolean
  splitPots: boolean
}

export const initialState: featureToggleState = {
  territoryAttendanceUK: false,
  territoryAttendanceNeth: false,
  notificationLogs: false,
  birthdayRequest: false,
  enhancement: undefined,
  manAuthUK: false,
  myActionsV3: undefined,
  ukPlannerDayforceAbsence: false,
  splitPots: false,
}

// Action Types
const SET_TERRITORY_ATTENDANCE_UK = 'SET_TERRITORY_ATTENDANCE_UK'
const SET_TERRITORY_ATTENDANCE_NETH = 'SET_TERRITORY_ATTENDANCE_NETH'
const NOTIFICATION_LOGS = 'NOTIFICATION_LOGS'
const SET_BIRTHDAY_REQUEST = 'SET_BIRTHDAY_REQUEST'
const SET_ENHANCEMENT = 'SET_ENHANCEMENT'
const SET_MAN_AUTH_UK = 'SET_MAN_AUTH_UK'
const SET_MYACTIONSV3 = 'SET_MYACTIONSV3'
const SET_UK_PLANNER_DAYFORCE_ABSENCE = 'SET_UK_PLANNER_DAYFORCE_ABSENCE'
const SET_SPLIT_POTS = 'SET_SPLIT_POTS'

// Action Creators
interface SetTerritoryAttendanceUK {
  type: typeof SET_TERRITORY_ATTENDANCE_UK
  payload: boolean
}

interface SetTerritoryAttendanceNeth {
  type: typeof SET_TERRITORY_ATTENDANCE_NETH
  payload: boolean
}


interface SetNotificationLogs {
  type: typeof NOTIFICATION_LOGS
  payload: boolean
}

interface SetBirthdayRequest {
  type: typeof SET_BIRTHDAY_REQUEST
  payload: boolean
}

interface SetEnhancement {
  type: typeof SET_ENHANCEMENT
  payload?: boolean
}

interface SetMyActionsV3 {
  type: typeof SET_MYACTIONSV3
  payload: boolean
}

interface SetManAuthUK {
  type: typeof SET_MAN_AUTH_UK
  payload: boolean
}

interface SetUkPlannerDayforceAbsence {
  type: typeof SET_UK_PLANNER_DAYFORCE_ABSENCE
  payload: boolean
}

interface SetSplitPots {
  type: typeof SET_SPLIT_POTS
  payload: boolean
}

type featureToggleDispatchTypes =
  | SetTerritoryAttendanceUK
  | SetTerritoryAttendanceNeth
  | SetNotificationLogs
  | SetBirthdayRequest
  | SetEnhancement
  | SetMyActionsV3
  | SetManAuthUK
  | SetUkPlannerDayforceAbsence
  | SetSplitPots

// Actions
export const setTerritoryAttendanceUK = (isOn: boolean): SetTerritoryAttendanceUK => ({
  type: SET_TERRITORY_ATTENDANCE_UK,
  payload: isOn,
})

export const setTerritoryAttendanceNeth = (isOn: boolean): SetTerritoryAttendanceNeth => ({
  type: SET_TERRITORY_ATTENDANCE_NETH,
  payload: isOn,
})
export const setNotificationLogs = (isOn: boolean): SetNotificationLogs => ({
  type: NOTIFICATION_LOGS,
  payload: isOn,
})

export const setBirthdayRequest = (isOn: boolean): SetBirthdayRequest => ({
  type: SET_BIRTHDAY_REQUEST,
  payload: isOn,
})

export const setEnhancement = (isOn?: boolean): SetEnhancement => ({
  type: SET_ENHANCEMENT,
  payload: isOn,
})

export const setMyActionsV3 = (isOn: boolean): SetMyActionsV3 => ({
  type: SET_MYACTIONSV3,
  payload: isOn,
})

export const setManAuthUK = (isOn: boolean): SetManAuthUK => ({
  type: SET_MAN_AUTH_UK,
  payload: isOn,
})

export const setUkPlannerDayforceAbsence = (isOn: boolean): SetUkPlannerDayforceAbsence => ({
  type: SET_UK_PLANNER_DAYFORCE_ABSENCE,
  payload: isOn,
})

export const setSplitPots = (isOn: boolean): SetSplitPots => ({
  type: SET_SPLIT_POTS,
  payload: isOn,
})

// Reducer
export const featureToggleReducer = (
  state: featureToggleState = initialState,
  action: featureToggleDispatchTypes
): featureToggleState => {
  switch (action.type) {
    case SET_TERRITORY_ATTENDANCE_UK:
      return { ...state, territoryAttendanceUK: action.payload }
    case SET_TERRITORY_ATTENDANCE_NETH:
      return { ...state, territoryAttendanceNeth: action.payload }
    case NOTIFICATION_LOGS:
      return { ...state, notificationLogs: action.payload }
    case SET_BIRTHDAY_REQUEST:
      return { ...state, birthdayRequest: action.payload }
    case SET_ENHANCEMENT:
      return { ...state, enhancement: action.payload }
    case SET_MYACTIONSV3:
      return { ...state, myActionsV3: action.payload }
    case SET_MAN_AUTH_UK:
      return { ...state, manAuthUK: action.payload }
    case SET_UK_PLANNER_DAYFORCE_ABSENCE:
      return { ...state, ukPlannerDayforceAbsence: action.payload }
    case SET_SPLIT_POTS:
      return { ...state, splitPots: action.payload }
    default:
      return state
  }
}
